import * as React from 'react';
import cn from 'classnames';
import { PaymentMethodScreenProps } from '../../../../types/AdaptedComponents';
import { UILibrary } from '../../../../types/UILibrary';
import { Text } from 'wix-ui-tpa/Text';
import InfoIcon from 'wix-ui-icons-common/InfoCircle';
import { classes } from './styles.st.css';
import { useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../redux/selectors';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';

export const PaymentMethodScreen: React.FC<PaymentMethodScreenProps> = (
  props
) => {
  const deviceType = useSelector(selectDeviceType);

  return (
    <div
      data-ui-lib={'tpa' as UILibrary}
      data-hook={props.dataHook}
      className={cn({
        [classes.root]: true,
        [classes.mobile]: deviceType === DeviceType.Mobile,
      })}
    >
      <Text>
        {props.title}
        <div className={classes.descriptionContainer}>
          <div>
            <InfoIcon size="24" className={classes.icon} />
          </div>
          <div className={classes.text}>{props.children}</div>
        </div>
      </Text>
    </div>
  );
};
PaymentMethodScreen.displayName = 'PaymentMethodScreen';
